export enum TagType {
  NEW,
  V3,
}
